import { AspectDimensions } from '@lib.core/entities/indicator/indicator';
import { AspectContext } from '@lib.core/entities/indicator/indicator-context';

export class AspectDatapoint {
  factNameId: string;
  year: number;
  month?: number;
  context: AspectContext;
  dimensions: AspectDimensions;
  value: number;

  constructor(
    nameId: string,
    year: number,
    month: number | undefined,
    context: AspectContext,
    dimensions: AspectDimensions,
    value: number
  ) {
    this.factNameId = nameId;
    this.year = year;
    this.month = month;
    this.context = context;
    this.dimensions = dimensions;
    this.value = value;
  }
}